// extracted by mini-css-extract-plugin
export default {"label":"prompt_label__YJzJG","element":"prompt_element__CCY1r"};